import * as React from 'react';



export default class More extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg
        {...this.props}
        className={this.props.className}
        xmlnsXlink="http://www.w3.org/1999/xlink"
        style={{ cursor: 'pointer', ...(this.props.style || {}) }}
      >
        <g id="exzeo_2.x_icon_set" stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(-400.000000, -225.000000)">
        <g id="Group-78" transform="translate(400.000000, 225.000000)">
            <g id="Group-2" transform="translate(8.264706, 7.735294) scale(-1, 1) rotate(90.000000) translate(-8.264706, -7.735294) translate(6.764706, 0.235294)">
                <circle id="Oval-2" cx="1.5" cy="1.5" r="1.5"></circle>
                <circle id="Oval-2-Copy" cx="1.5" cy="7.5" r="1.5"></circle>
                <circle id="Oval-2-Copy-2" cx="1.5" cy="13.5" r="1.5"></circle>
            </g>
            </g>
        </g>
      </svg>
    )
  }
}
